/**
 * TableFilter  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useMemo } from "react";
import { getBaseClass } from "./baseClass";
import { useTableContext } from "./TableContext";

export interface ITableFilterProps {
	className?: string;
}

export const TableFilter: React.FC<ITableFilterProps> = ({ children, className }) => {
	const { headerHeight } = useTableContext();

	const style = useMemo(() => (isFinite(headerHeight) ? { top: headerHeight + 1 } : {}), [ headerHeight ]);

	const baseClass = getBaseClass("table-filter");

	if (className) {
		baseClass.add(className);
	}

	return (
		<tr className={baseClass.toClassName()} style={style}>
			{children}
		</tr>
	);
};
